import React, { Component } from "react";
import "./index.scss";
import ReferralCard from "./components/referralCard";
import Loader from "../Shared/Loader";
import { dummyData } from "./helper/dataSkeleton";
import Pagination from "../Shared/DexterPagination/Pagination";
import { subDays } from "date-fns";
import { Redirect } from "react-router-dom";
import AddCampaign from "./components/AddCampaign";
import SearchBar from "../Shared/SearchBar/SearchBar";
import { referralService } from "./services/referralService";
import axios from "axios";

class ServiceReferral extends Component {
  constructor(props) {
    super(props);
    this.state = {
      referrals: [],
      filteredReferrals: [],
      loading: false,
      currentPage: 1,
      itemsPerPage: 10,
      totalItems: 0,

      filters: {},
      searchTerm: "",
      dateRange: [
        {
          startDate: subDays(new Date(), 7),
          endDate: new Date(),
          key: "selection",
        },
      ],
    };

    // Reference to cancel token
    this.cancelTokenSource = null;
  }

  componentDidMount() {
    const localUserToken = JSON.parse(localStorage.getItem("currUserToken"));
    if (localUserToken) {
      this.fetchReferrals();
    }
  }

  componentWillUnmount() {
    // Cancel any pending requests when component unmounts
    if (this.cancelTokenSource) {
      this.cancelTokenSource.cancel("Component unmounted");
    }
  }

  fetchReferrals = async () => {
    // Cancel previous request if it exists
    if (this.cancelTokenSource) {
      this.cancelTokenSource.cancel("New request made");
    }

    // Create a new cancel token
    this.cancelTokenSource = axios.CancelToken.source();

    this.setState({ loading: true });
    const { currentPage, searchTerm } = this.state;

    try {
      const data = await referralService.fetchReferrals(
        currentPage,
        searchTerm,
        this.cancelTokenSource.token
      );

      const referrals = data.data;

      this.setState({
        referrals,
        filteredReferrals: referrals,
        totalItems: data.count,
        loading: false,
      });
    } catch (error) {
      if (!axios.isCancel(error)) {
        // Only update state if this wasn't a cancelled request
        console.error("Error fetching referrals:", error);
        this.setState({
          loading: false,
        });
      }
    }
  };

  onPageChange = (page) => {
    this.setState({ currentPage: page }, () => this.fetchReferrals());
  };

  // Debounce function to delay API calls
  debounce = (func, delay) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  };

  // Create a debounced version of fetchReferrals
  debouncedFetchReferrals = this.debounce(() => {
    this.fetchReferrals();
  }, 500);

  handleSearch = (searchTerm) => {
    this.setState({ searchTerm }, () => {
      // Use the debounced version to prevent excessive API calls
      this.debouncedFetchReferrals();
    });
  };

  handleStatusChanged = () => {
    this.fetchReferrals();
  };

  render() {
    const localUserToken = JSON.parse(localStorage.getItem("currUserToken"));
    if (!localUserToken) return <Redirect to="/signin" />;

    const { filteredReferrals, totalItems, loading } = this.state;

    return (
      <div className="service-referral-container">
        <div className="service-referral-header">
          <div className="referral-actions">
            <SearchBar
              value={this.state.searchTerm}
              onSearch={this.handleSearch}
              placeholder="Search campaigns..."
            />
            <AddCampaign onCampaignAdd={this.fetchReferrals} />
          </div>
          {totalItems > 0 && (
            <div className="pagination-section">
              <Pagination
                currentPage={this.state.currentPage}
                totalCount={totalItems}
                pageSize={this.state.itemsPerPage}
                onPageChange={this.onPageChange}
              />
            </div>
          )}
        </div>

        <div className="service-referral-cards-container">
          {loading && <FetchingOverlay />}
          {filteredReferrals.length === 0 && !loading && (
            <h2 className="no-data-container">No matching campaigns found</h2>
          )}
          {filteredReferrals.map((referral) => (
            <ReferralCard
              key={referral.id || referral.campaign_id}
              referralInfo={{
                ...referral,
              }}
              onStatusChanged={this.handleStatusChanged}
            />
          ))}
        </div>
      </div>
    );
  }
}

const FetchingOverlay = () => {
  return (
    <div className="referral-fetching-overlay">
      <Loader name="referral" />
    </div>
  );
};

export default ServiceReferral;
